const headerIdentifier = "pm2--header";
const headerSelector = `.${headerIdentifier}`;

export { headerIdentifier, headerSelector };
//# sourceMappingURL=selectors.js.map
